import { find, orderBy } from 'lodash-es';
import { isStateAuthorized } from './nav.util.service';

export default function NavService(
  $state,
  $rootScope,
  alertsNavService,
  adminNavService,
  devicesNavService,
  maintenanceNavService,
  mapNavService,
  equipmentNavService,
  tSeriesNavService,
  reportsNavService,
  accessManagemantNavService,
  usersService,
  userProfileNavService,
  siteNaveService, //eslint-disable-line no-unused-vars
) {
  'ngInject';
  //Compile all of the modules based on the arguments of the nav services injected in here

  let modules = Object.entries(arguments).reduce((map, [, module]) => {
    if (typeof module.getModule === 'function') {
      let result = module.getModule();
      map[result.id] = result;
    }

    return map;
  }, {});

  let _showingNavService = false;

  this.isShowingSideNav = () => {
    return _showingNavService;
  };

  this.toggleSideNav = () => {
    _showingNavService = !_showingNavService;
  };

  this.hideSideNav = () => {
    _showingNavService = false;
  };

  this.showSideNav = () => {
    _showingNavService = true;
  };

  this.getModules = () => {
    return modules;
  };

  this.getModuleByState = (sref) => find(modules, (m) => sref.startsWith(m.sref));

  this.getCurrentModule = () => this.getModuleByState($state.current.name);

  this.getFirstValidSubItemState = (sref) => {
    const stateModule = this.getModuleByState(sref) || {};
    return (stateModule.items || []).find((item) => this.isValidState(item.sref));
  };

  this.getFirstValidTopNavItem = () => {
    return orderBy(
      Object.keys(modules).map((module) => modules[module]),
      'priority',
      ['desc'],
    ).find((module) => this.isValidState(module.sref));
  };

  this.isValidState = (stateName) => {
    const currentUser = usersService.currentUser();
    //Means we haven't loaded the current user so its not a valid state
    if (!currentUser) {
      return false;
    }
    const state = $state.get(stateName);

    //this is a hard coded fix for the UR dashboard
    return state.name === 'assetdashboard' || isStateAuthorized(state, currentUser);
  };
}
